import React from 'react';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import UpcomingMeetingsTable from './Employee/UpcomingMeetingsTable';

const TablesContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: '18px',
  marginBottom: '18px'
}));

const TablesSection = ({ meetingsData }) => {
  return (
   <TablesContainer>
     <UpcomingMeetingsTable data={meetingsData} />
   </TablesContainer>
  );
};

export default TablesSection;